export const CLASS_CODES_PATH = '/admin/class-codes';
export type ClassCodeStatusFilter = 'active' | 'archived' | 'all';
export interface ClassCodesListParams {
  status: ClassCodeStatusFilter;
  q: string;
}

export function parseClassCodesListParams(
  params: URLSearchParams
): ClassCodesListParams {
  const status = params.get('status');
  return {
    status: status === 'archived' || status === 'all' ? status : 'active',
    q: (params.get('q') ?? '').trim().slice(0, 200),
  };
}

export function classCodesListSearch(filters: ClassCodesListParams): string {
  const params = new URLSearchParams();
  if (filters.status !== 'active') params.set('status', filters.status);
  const q = filters.q.trim().slice(0, 200);
  if (q) params.set('q', q);
  return params.toString();
}

export function classCodesReturnTo(filters: ClassCodesListParams): string {
  const search = classCodesListSearch(filters);
  return `${CLASS_CODES_PATH}${search ? `?${search}` : ''}`;
}
